// Libs
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

// Components
import Banner from '~fpu/modules/MemberDashboard/components/Courses/Banner';
import HLSVideoPlayer from '~fpu/shared/components/HLSVideoPlayer';
import { PlayIconBlue } from '~fpu/shared/components/icons/play-icon/PlayIconBlue';

// Hooks
import { useHasFpuAllAccess } from '~fpu/shared/hooks/useHasFpuAllAccess';

// Utils
import { analyticsLogger } from '~fpu/shared/utils/analytics';

// Constants
import { PATHS } from '~fpu/config/constants';

function BorrowedFuture() {
  const { data: hasFpuAllAccess, isFetched } = useHasFpuAllAccess();
  const navigate = useNavigate();

  const video = {
    src: 'https://streaming.ramseysolutions.net/video/StreamingTV/borrowed_future_final.mp4/hls/borrowed_future_final.m3u8',
    thumbnail:
      'https://cdn.ramseysolutions.net/media/b2c/broadcast/borrowed-future-landing-page/headers/bf-brush-header-wide.jpg'
  };

  useEffect(() => {
    if (isFetched && !hasFpuAllAccess) {
      navigate(PATHS.MEMBER_DASHBOARD.BASE);
    }
  }, [hasFpuAllAccess, isFetched, navigate]);

  const handlePlay = () => {
    analyticsLogger.trackElementClicked({
      element: 'Course Lesson Player',
      label: 'Borrowed Future'
    });
  };

  if (!hasFpuAllAccess) {
    return null;
  }

  return (
    <div className="max-w-[1200px]">
      <Banner activityId="borrowed-future" />

      <HLSVideoPlayer
        onPlay={handlePlay}
        src={video.src}
        thumbnail={video.thumbnail}
        data-testid="video-player-borrowed-future"
        playIcon={
          <PlayIconBlue className="absolute top-1/2 left-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full border-white transition duration-300 ease-in-out group-hover:scale-125 group-hover:border-[6px] group-hover:border-white sm:h-[84px] sm:w-[84px] md:h-[104px] md:w-[104px] lg:h-[84px] lg:w-[84px] xl:h-[104px] xl:w-[104px]" />
        }
      />
    </div>
  );
}

export default BorrowedFuture;
